import React from 'react';
import AtomicButton from '../../atomic/button/AtomicButton';
import ERROR_404 from "../../global/assets/svg/Error404.svg";
import variables from "../../global/assets/_variables.scss";
import { ERROR_404_MSG } from "../../global/constants";
import "./Error404.scss";

export const Error404Mobile = () => {
    const styleButton = {
        backgroundColor: variables.backgroundButtonBlue,
        width: "50%",
        marginTop: "15px",
        marginBottom: "15px",
        height: "46px"
    };
    const tryAgain = () => {
        window.location.reload()

    };
    return (
        <div className='error-404-mobile-container'>
            <div className='sorry-text'>{ERROR_404_MSG}</div>
            <img src={ERROR_404} alt="" />
            <AtomicButton
                label="Try again"
                handleSubmit={tryAgain}
                style={styleButton}
            />
        </div>
    )
}
